// src/pages/VinculacionForm.js
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Paper, Typography, TextField, Button, Box, Alert } from '@mui/material';
import api from '../api/axiosConfig';

const VinculacionForm = () => {
  const { idPoa, idActividad, idPartida } = useParams();
  const navigate = useNavigate();
  const user = localStorage.getItem('user');

  const [formData, setFormData] = useState({
    id_poatres_actividad: parseInt(idActividad, 10),
    id_plandecuenta: '',
    recurso: '',
    cantidad: 1,
    unidad: '',
    precio: 0,
    total: 0,
  });

  const [cuentas, setCuentas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Cargar plan de cuentas (nivel 4)
  useEffect(() => {
    const fetchCuentas = async () => {
      try {
        const res = await api.get('/plan-de-cuentas/?nivel=4');
        setCuentas(res.data);
      } catch (err) {
        console.error('Error al cargar cuentas:', err);
      }
    };
    fetchCuentas();
  }, []);

  // Calcular total
  useEffect(() => {
    const total = parseFloat(formData.cantidad * formData.precio) || 0;
    setFormData(prev => ({ ...prev, total: parseFloat(total.toFixed(2)) }));
  }, [formData.cantidad, formData.precio]);

  // Cargar datos si es edición
  useEffect(() => {
    if (idPartida) {
      const fetchPartida = async () => {
        setLoading(true);
        try {
          const res = await api.get(`/poa-partidas/${idPartida}/`);
          setFormData(res.data);
        } catch (err) {
          setError('Error al cargar partida');
        } finally {
          setLoading(false);
        }
      };
      fetchPartida();
    }
  }, [idPartida]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const payload = {
      ...formData,
      creado_por: user,
      modificado_por: user,
    };

    try {
      if (idPartida) {
        await api.put(`/poa-partidas/${idPartida}/`, {
          ...formData,
          modificado_por: user,
        });
      } else {
        await api.post('/poa-partidas/', payload);
      }
      navigate(`/poa/${idPoa}/matriz/${idActividad}/partidas`);
    } catch (err) {
      console.error('Error al guardar partida:', err.response || err);
      setError(err.response?.data?.detail || 'Error al guardar. Verifica los datos.');
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="md">
      <Paper sx={{ p: 3, mt: 3 }}>
        <Typography variant="h5" gutterBottom>
          {idPartida ? 'Editar Partida' : 'Nueva Partida'}
        </Typography>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            select
            label="Cuenta Presupuestaria *"
            fullWidth
            value={formData.id_plandecuenta}
            onChange={(e) => setFormData({ ...formData, id_plandecuenta: e.target.value })}
            margin="normal"
            required
          >
            {cuentas.map(cuenta => (
              <option key={cuenta.id_plandecuenta} value={cuenta.id_plandecuenta}>
                {cuenta.partida}.{cuenta.generica}.{cuenta.especifica}.{cuenta.subespecifica} - {cuenta.denominacion}
              </option>
            ))}
          </TextField>

          <TextField
            label="Recurso *"
            fullWidth
            value={formData.recurso}
            onChange={(e) => setFormData({ ...formData, recurso: e.target.value })}
            margin="normal"
            required
          />

          <TextField
            label="Cantidad *"
            type="number"
            fullWidth
            value={formData.cantidad}
            onChange={(e) => setFormData({ ...formData, cantidad: Number(e.target.value) || 0 })}
            margin="normal"
            required
          />

          <TextField
            label="Unidad *"
            fullWidth
            value={formData.unidad}
            onChange={(e) => setFormData({ ...formData, unidad: e.target.value })}
            margin="normal"
            required
          />

          <TextField
            label="Precio *"
            type="number"
            fullWidth
            value={formData.precio}
            onChange={(e) => setFormData({ ...formData, precio: Number(e.target.value) || 0 })}
            margin="normal"
            required
          />

          <TextField
            label="Total"
            fullWidth
            value={formData.total}
            margin="normal"
            disabled
          />

          <Box sx={{ mt: 2 }}>
            <Button
              type="submit"
              variant="contained"
              disabled={loading}
              sx={{ mr: 1 }}
            >
              {loading ? 'Guardando...' : idPartida ? 'Actualizar' : 'Guardar'}
            </Button>
            <Button onClick={() => navigate(`/poa/${idPoa}/matriz/${idActividad}/partidas`)}>
              Cancelar
            </Button>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default VinculacionForm;